<template>
    <v-card flat height="190" class="d-flex flex-column align-center justify-center">
        <template v-if="importInProgress">
            <v-progress-circular indeterminate color="primary" size="40" class="mb-3"></v-progress-circular>
            <div>
                {{ progressText ? progressText + '...' : "Import in progress..." }}
            </div>
        </template>
        <template v-else-if="importSuccess">
            <v-icon color="success" size="50" class="mb-2">
                mdi-check-circle
            </v-icon>
            <div>Import success</div>
            <v-btn color="primary" small class="mt-2" @click="reset()">
                Upload another file
            </v-btn>
        </template>
        <template v-else-if="importError">
            <v-icon color="error" size="50" class="mb-2">
                mdi-alert
            </v-icon>
            <div>Import failed</div>
            <div>{{ importError.message }}</div>
            <v-btn color="primary" small class="mt-3" @click="reset()">
                Upload another file
            </v-btn>
        </template>
        <template v-else>
            <div style="height: 100%; width: 100%;">
                <drop-pad v-show="!uploadFile" accept=".xlsx,.xls,.xml" :outlined="true" :disabled="false"
                    @fileDrop="handleFileDrop" @click="clickFileInput()">
                </drop-pad>
                <template>
                    <div v-show="uploadFile" class="text-center">
                        <div>Uploading file to server...</div>
                        <v-file-input v-model="uploadFile" ref="fileinput" color="primary" accept=".xlsx,.xls,.xml"
                            :label="uploadFile != null ? 'File' : 'Click here to select file'" placeholder="Select file"
                            prepend-icon="" outlined :show-size="1000" dense class="ma-3">
                            <template v-slot:selection="{ index, text }">
                                <v-chip v-if="index < 2" color="primary" dark label>
                                    {{ text }}
                                </v-chip>
                            </template>
                        </v-file-input>
                    </div>
                </template>
            </div>
        </template>
    </v-card>
</template>


<script>
import ClientAPIMixin from '@/api/ClientAPIMixin';
import DropPad from "@/components/SingleUse/DropPad.vue";

export default {
    name: 'ImportVisualizer',
    props: {
        importInProgress: Boolean,
        progressText: String,
        importError: Object,
        importSuccess: Object,
    },
    components: {
        DropPad,
    },
    mixins: [ClientAPIMixin],

    data() {
        return {
            uploadFile: null,
        };
    },

    methods: {
        reset() {
            this.uploadFile = null;
            this.$emit('reset');
        },

        handleFileDrop(file) {
            this.uploadFile = file;
        },

        clickFileInput() {
            const elem = this.$refs.fileinput.$refs.input
            //console.log(elem);
            elem.click()
        },

        async handleSave() {
            if (!this.uploadFile) {
                return;
            }
            await this.importFile(this.uploadFile).then(() => {
                console.log("File uploaded successfully.");
                this.uploadFile = null;
            });
        },
    },

    computed: {},

    watch: {
        uploadFile: function () {
            this.handleSave();
        },
    },
};
</script>


<style lang='scss' scoped></style>